module.exports = __webpack_public_path__ + "static/media/rober1.e479a99c.jpg";